import { assign } from '@atds-legacy/lang';
import { Record, Resource } from '@redge-media/fo-js-sdk';

const Profiles = Resource.extend({
  endpoint: 'subscribers/profiles',

  constructor: function Profiles(subscriber) {
    Resource.call(assign(this, {
      subscriber,
    }));

    this.subscriber.on('sync', () => {
      this.collection.reset();
      this.collection.isFetched = false;

      if (!this.subscriber.isLogged) {
        return this.reset();
      }

      if (this.subscriber.profiles && this.subscriber.profiles.length) {
        const profilesList = this.subscriber.profiles.slice().sort((a, b) => {
          return new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime();
        });

        const records = this.wrap(profilesList);
        this.collection.add(records);
        this.collection.isFetched = true;
      }
    });

    this.on('sync', this.sync, this);
  },

  sync(method, profile = {}) {
    if (method === 'update' && profile.id === this.subscriber.activeProfileId) {
      this.subscriber.emit('sync:profile', profile);
    }
  },

  getPath(method, opts) {
    if (method === 'create') {
      return this.endpoint;
    }

    if (method === 'update' || method === 'destroy') {
      return `${this.endpoint}/${opts.id}`;
    }
  },

  createRecord(props = {}, opts = {}) {
    if (props instanceof Record) {
      return props;
    }

    const item = props.item || props;
    if (!item.avatar) {
      item.avatar = {};
    }

    return new Record(item, opts);
  },
});

export default Profiles;
